import React from "react";
import { Row, Col } from "reactstrap";
import "./site-footer.component.scss";
import AdscritosBlock from "../adscritos-block/adscritos-block.component";
import {ReactComponent as Facebook} from '../../assets/icons/svg/icon_facebook.svg';
import {ReactComponent as Twetter} from '../../assets/icons/svg/icon_twitter.svg';
import {ReactComponent as Flickr} from '../../assets/icons/svg/icon_flikr.svg';
import {ReactComponent as Youtube} from '../../assets/icons/svg/icon_youtube-play.svg';
class SiteFooterOrgs extends React.Component {
  render() {
    return (
      <footer>
         <AdscritosBlock/>
        <div className="footer-body-container">
          <div className="container">
            <Row>
              <Col lg="12" sm="12" className="site-footer__block mb-4">
                <h4>Ministerio del Ambiente</h4>
                <p>Dirección de Información e Investigación Ambiental.</p>
                <p>
                  Av. Antonio Miró Quesada N°425 (ex Juan de Aliaga)
                </p>
                <p>
                  Urb. San Felipe - Magdalena del Mar, Lima
                </p>
                <p>(511) 6116000</p>
                <p>siniasoporte@minam.gob.pe</p>
                <div>
                    <span className="ml-2 icon-footer">
                      <a  href="https://www.facebook.com/MinamPeru/" target="_blank">
                      <Facebook />
                      </a>
                    </span>
                    <span className="ml-4 icon-footer">
                      <a className="ml-3" href="https://twitter.com/MinamPeru" target="_blank">
                      <Twetter />
                      </a>
                    </span>
                    <span className="ml-4 icon-footer">
                      <a className="ml-3" href="https://www.youtube.com/user/minamperu" target="_blank">
                      <Youtube />
                      </a>
                    </span>
                    <span className="ml-4 icon-footer">
                      <a className="ml-3" href="https://www.flickr.com/photos/minamperu/albums" target="_blank">
                      <Flickr />
                      </a>
                    </span>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </footer>
    );
  }
}
export default SiteFooterOrgs;
